import React from 'react'
import {NavHeadLinks} from '../../components/modules/pannelli/HeadLink';
import {MenuMobile} from '../../components/modules/pannelli/MenuMobile';
import {useThemes} from '../../components/hooks/hooks-mongoDB/useThemes';
import simSomXS from '../../components/images/sparetime/sagre/intestato/TraboccoW500.png';
import simSomS from '../../components/images/sparetime/sagre/intestato/TraboccoW800.png';
import simSomM from '../../components/images/sparetime/sagre/intestato/TraboccoW1200.png';
import simSomL from '../../components/images/sparetime/sagre/intestato/TraboccoW1600.png';
import simSomXL from '../../components/images/sparetime/sagre/intestato/TraboccoW2000.png';
import simSomXXL from '../../components/images/sparetime/sagre/intestato/TraboccoW3500.png';
import './sagre-abruzzo.scss';

function SagreAbruzzese() {
    const {themes} = useThemes();
    const sagreTheme = themes[11];

    return (
        <section>
            {sagreTheme && <NavHeadLinks title={sagreTheme.name} picB={simSomXS}  picS={simSomS} picM={simSomM} picL={simSomL} picXL={simSomXL} picXXL={simSomXXL} />}
            <div className="accordion--map">
                {sagreTheme && <div className = "container--title">
                    <h1 className = "title__top"> {sagreTheme.name} </h1>
                </div>}
            </div>
            <MenuMobile temi={themes}/>
            <div className="sagre-container">
                <div className="sagre-card">
                    <h1>🚧 Lavori in corso</h1>
                    <p>
                    Questa pagina è attualmente in costruzione.
                    Torna più tardi per vedere gli aggiornamenti.
                    </p>
                </div>
            </div>
        </section>
    )
}
export default SagreAbruzzese;
